/**
 * Lectura síncrona del consentimiento del usuario, fuera de React.
 *
 * `useConsent` (ConsentManager) es la fuente canónica y quien lo escribe; este
 * módulo solo LEE, para los consumidores que no son componentes: el arranque de
 * Sentry y el listener del bus de analítica.
 *
 * Vive aparte a propósito: la lógica estaba duplicada dentro de `sentryInit.js`
 * como función privada, y el listener la necesitaba también. Una tercera copia
 * habría acabado divergiendo — que es exactamente lo que pasó con las dos
 * implementaciones de consentimiento que se unificaron en #1712.
 */

import { safeStorage } from '@/lib/safeStorage';

/** Clave canónica. Espejo de `CONSENT_KEY` en ConsentManager. */
export const CONSENT_KEY = 'verix_consent_v1';

/**
 * ¿El usuario consintió analítica?
 *
 * Por defecto NO: sin registro, o con un JSON ilegible, se devuelve `false`. El
 * consentimiento exige un acto afirmativo (RGPD Art. 4.11), así que el silencio
 * nunca puede interpretarse como un sí.
 */
export function hasAnalyticsConsent() {
  try {
    const raw = safeStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    const consent = JSON.parse(raw);
    // `revoked_at` lo pone `revokeConsent` al confirmarlo el servidor (#1712).
    if (consent?.revoked_at) return false;
    return consent?.analytics === true;
  } catch {
    return false;
  }
}
